import React from 'react';
import { Link } from 'react-router-dom';
import * as RT from '../../constants/Routing';
import ParticipantCard from '../../components/Parts/ParticipantCard';
import { isEmpty } from '../../lib/function';
export default class Component extends React.Component {
  constructor(props) {
    super(props);
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
  }

  // 必要なprops

  closeModal = () => {
    const dialog = document.querySelector('.dialog.active');
    dialog.classList.remove('fadein');
    dialog.classList.add('fadeout');
    setTimeout(() => {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.closeModal();
    }, 1000);
  };

  componentDidMount = () => {};

  render = () => {
    console.log('TCL: Component -> render -> this.props', this.props);
    const className = this.props.className
      ? this.props.className + (this.props.isOpen ? 'active fadein' : '')
      : `dialog ${this.props.isOpen ? 'active fadein' : ''}`;
    return (
      <div className={className}>
        <div className="dialog-wrapper">
          <div className="dialog-container invoice-modal shadow-sm">
            <div className="dialog-body">
              {this.props.user && !isEmpty(this.props.user) && (
                <ParticipantCard
                  participant={this.props.user}
                  enterpriseId={this.currentUser.enterpriseId}
                  token={this.currentUser.accessToken}
                  taskId={this.props.task.task_id}
                  key={this.props.user.taskrewId}
                  isFrom={'modal'}
                  noBtn
                />
              )}
              <div>
                <div
                  onClick={() => this.props.closeModal()}
                  className="btn btn-primary btn-md task-btn float-right"
                  style={{ fontSize: 20, opacity: '50%', backgroundColor: 'gray' }}
                >
                  閉じる
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}
